<template>
  <div class>
    <h1 style="text-align: center;"><strong>使用</strong><strong>CFCA</strong><strong>电子签约服务的告知同意内容</strong></h1>
<p>&nbsp;</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp;我公司已阅读并认可&ldquo;安心签&rdquo;平台服务协议、隐私条款、数字证书管理协议，以及《CFCA数字证书服务协议》，同意受前述协议的约束。我公司同意使用北京中金国信科技有限公司提供的&ldquo;安心签&rdquo;电子合同平台服务，以及中金金融认证中心有限公司（简称&ldquo;CFCA&rdquo;）为&ldquo;安心签&rdquo;提供的第三方电子认证服务。我公司同意向CFCA申请、绑定数字证书，并使用该等数字证书通过&ldquo;安心签&rdquo;平台签署电子合同。</p>
<p>&nbsp;</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp;我公司同意通过祺信平台向&ldquo;安心签&rdquo;平台提供我公司${customerName}信息，以便我公司使用&ldquo;安心签&rdquo;平台服务和电子认证服务。</p>
 <div class="spaceCenter">
                <a-button type="primary" style="margin:30px 5px;width:90px;" @click="okModal()">下一步</a-button>
            </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
     okModal(){
          this.$emit("ok");
        },
  },
  created() {},
  mounted() {},
  activated() {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components-frame/CFCA.vue